import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SecondaryButton from '../atoms/SecondaryButton'
import PromotionPhotosModal from './PromotionPhotosModal'
import { MotorbikePhoto } from 'src/redux/photosReducer'

interface PromotionPhotosFieldProps {
  photos: MotorbikePhoto[]
  selectedIds: string[]
  coverId: string | null
  maxImages: number | null
  onChange: (ids: string[], coverId: string | null) => void
}

const PromotionPhotosField = ({
  photos,
  selectedIds,
  coverId,
  maxImages,
  onChange
}: PromotionPhotosFieldProps): JSX.Element => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const selected = photos.filter((photo) => selectedIds.includes(photo.id))

  return (
    <div className="self-stretch bg-neutral-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-borders-border-base inline-flex flex-col justify-start items-start">
      <div className="self-stretch h-14 px-4 py-3 inline-flex justify-between items-center">
        <div className="justify-start text-foregrounds-fg-base text-sm font-semibold font-Montserrat leading-5">
          {t('my_vehicles.promotion_photos')}
        </div>
        <SecondaryButton
          size="base"
          onClick={() => {
            setOpen(true)
          }}>
          {t('my_vehicles.promotion_photos_pick')}
        </SecondaryButton>
      </div>
      <div className="self-stretch px-4 pb-4">
        {selected.length === 0 ? (
          <div className="text-sm font-medium font-Montserrat text-foregrounds-fg-subtle">
            {t('my_vehicles.promotion_photos_none')}
          </div>
        ) : (
          <div className="flex flex-wrap gap-3">
            {selected.map((photo) => (
              <div key={photo.id} className="relative w-28 h-20">
                <img
                  src={photo.thumb_url ?? photo.url ?? ''}
                  alt=""
                  className="w-28 h-20 rounded-lg object-cover bg-white"
                />
                {photo.id === coverId && (
                  <span className="absolute left-1 top-1 rounded bg-Estigroup-primary px-1 text-[10px] font-semibold leading-4 text-white">
                    {t('my_vehicles.promotion_photo_cover')}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      {open && (
        <PromotionPhotosModal
          photos={photos}
          selectedIds={selectedIds}
          coverId={coverId}
          maxImages={maxImages}
          onClose={() => {
            setOpen(false)
          }}
          onConfirm={(ids, nextCoverId) => {
            onChange(ids, nextCoverId)
            setOpen(false)
          }}
        />
      )}
    </div>
  )
}

export default PromotionPhotosField
